import React from 'react';
import { motion } from 'framer-motion';
import { Clock, UserMinus, AlertTriangle } from 'lucide-react';
const painPoints = [{
  icon: Clock,
  title: 'Weeks to fill a single seat',
  description: 'Manual screening, phone tag, and waiting on background checks keeps your trucks parked and costing you money.'
}, {
  icon: UserMinus,
  title: 'Qualified drivers drop off',
  description: 'Good drivers are off the market in 48 hours. If you take days to review an application, they accept other offers.'
}, {
  icon: AlertTriangle,
  title: 'Hours Spent Phone Screening',
  description: 'Manually reviewing driving history and safety records is time-consuming, inconsistent, and risks putting unsafe drivers behind the wheel.'
}];
export function PainPoints() {
  return <section className="py-24 bg-slate-50" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-118">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-119">
            Hiring Drivers Shouldn't Be This Hard
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-600" data-id="element-120">
            The traditional hiring process is broken, slow, and costs fleet
            operators thousands in lost revenue per empty seat.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-121">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1 + 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-122">
              <div className="w-12 h-12 rounded-xl bg-red-50 flex items-center justify-center mb-6" data-id="element-123">
                <point.icon className="w-6 h-6 text-red-500" data-id="element-124" />
              </div>
              <h3 className="text-xl font-display font-bold text-slate-900 mb-3" data-id="element-125">
                {point.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-126">
                {point.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}